<template>
  <div>
    <div class="trainCalcDiv">
      <div class="paramMargin">
        <p class="instanceName">
          <span>{{ name }}</span>
          <a-button
            size="small"
            type="primary"
            style="margin-left: 1rem"
            @click="toHelpPage"
            >文档</a-button
          >
        </p>
      </div>
      <div class="mainContent">
        <my-params
          :params="this.trainParams"
          :inputType="this.inputType"
          buttonText="训练"
          v-if="paramsLoaded"
          v-on:commit="doTrain"
          :buttonable="trainButtonAble"
        ></my-params>
        <!-- <my-result v-show="resultShow"></my-result> -->
        <!-- <my-result v-show="resultShow"></my-result> -->
        <my-result v-if="result" :result="result" :showAlert="true"></my-result>
      </div>
    </div>
  </div>
</template>
<script>
import myParams from './params'
import myResult from './result'
import util from '../util'
export default {
  components: { myParams, myResult },
  data() {
    return {
      aid: '',
      name: '',
      trainParams: [],
      inputType: '',
      // resultShow: false,
      result: null,
      trainButtonAble: true,
      paramsLoaded: false
    }
  },
  mounted() {
    if (!this.$route.params.algorithmId) {
      this.$router.push('/instances')
      return ''
    }

    this.aid = this.$route.params.algorithmId
    this.$http.get(`/algorithm/${this.aid}/params`).then(resp => {
      this.trainParams = resp.data.params
      this.inputType = resp.data.input_type
      this.paramsLoaded = true
      this.name = resp.data.name
    })
  },
  methods: {
    async doTrain(event) {
      const resp = await this.$http.post(
        `/algorithm/${this.$route.params.algorithmId}/train`,
        event,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
      this.result = resp.data
      this.trainButtonAble = true
    },
    toHelpPage() {
      util.toAlgHelp(this.aid, this.$router, true)
    }
  }
}
</script>

<style scoped>
.mainContent {
  margin: auto;
  max-width: 60rem;
}
</style>
